firebird.controller('handoutDownloadsModalCtrl', [
    '$window',
    '$rootScope',
    '$scope',
    'logService',
    'socketService',
    'helperService',
    'attendeeService',
    function ($window, $rootScope, $scope, logService, socketService, helperService, attendeeService) {
        var self = this;

        self.attendantId = attendeeService.getAttendantId();

        self.onShowModal = onShowModal;
        self.onHideModal = onHideModal;
        self.onDownloadClick = onDownloadClick;
        self.onUpdateSharedFiles = onUpdateSharedFiles;

        self.modalState = 'closed';
        self.sharedFiles = [];

        $scope.$on('show-modal', self.onShowModal);
        $scope.$on('hide-modal', self.onHideModal);
        $scope.$on('get-shared-files-data', onUpdateSharedFiles);
        $scope.$on('shared-files-data-updated', onUpdateSharedFiles);

        init();

        ////////////////////////

        function init() {
            logService.log('handoutDownloadsModalCtrl - initialized');

            // Get Shared Files Data
            var msg = {
                message: 'get-shared-files-data',
                data: {},
                callback: self.onUpdateSharedFiles
            };
            socketService.send(msg);
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('handoutDownloads') !== -1) {
                self.modalState = 'closed';
            }

            digest();
        }

        function onShowModal(e, modalName) {
            if (modalName === 'handoutDownloads') {
                self.modalState = 'open';
            }
        }

        function onDownloadClick(fileDownloadContentId) {
            if (fileDownloadContentId !== undefined) {
                var msgObj = {
                    message: 'download-file-click',
                    data: {
                        id: self.attendantId,
                        contentId: fileDownloadContentId
                    }
                };
                socketService.send(msgObj);

                // Open Download Url in new Tab
                var fileDownloadURL =
                    helperService.getLocationProtocol() +
                    '://www.' +
                    helperService.getLocationHost() +
                    '/dl/' +
                    fileDownloadContentId;
                $window.open(fileDownloadURL, '_blank');
            }
        }

        function onUpdateSharedFiles(e, data) {
            self.sharedFiles = []; // Nullify an array

            for (var i = 0; i < data.ids.length; i++) {
                self.sharedFiles.push(data[data.ids[i]]);
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
